import { apiAuth, apiResponseType } from ".";

export const getRolesData = (page: number = 1): apiResponseType =>
  apiAuth.get(`roles?page=${page}`);

export const registerRoleData = (data: any) =>
  apiAuth.post("/roles/store", data) as apiResponseType;
export const deleteRoleData = (role_uuid: string) =>
  apiAuth.delete(`roles/${role_uuid}/destroy`) as apiResponseType;
export const updateRoleData = (role_uuid: string, data) =>
  apiAuth.put(`roles/${role_uuid}/update`, data) as apiResponseType;

export const getShowRole = (role_uuid: string) =>
  apiAuth.get(`roles/${role_uuid}/show`) as apiResponseType;

export const searchRoleData = (params: { name: string }): apiResponseType =>
  apiAuth.get(`roles?name=${params.name}`);

export const setStatusRole = (role_uuid: string) =>
  apiAuth.put(`roles/${role_uuid}/toggle-status`) as apiResponseType;

export const getSelectRoles = () =>
  apiAuth.get(`roles/select`) as apiResponseType;

export const getRolePermissions = () =>
  apiAuth.get(`roles/permissions`) as apiResponseType;
